import styled from '@emotion/styled/macro'
import { Chip } from '@material-ui/core'

interface LabelChipProps {
  $backgroundColor: string
  $color: string
  $inSelect: boolean
  $marginRight?: number
}

const LabelChip = styled(Chip, {
  shouldForwardProp: (prop) =>
    prop !== '$backgroundColor'
    && prop !== '$color'
    && prop !== '$inSelect'
    && prop !== '$marginRight',
})<LabelChipProps>`
  ${({ $backgroundColor }) => `background-color: ${$backgroundColor};`}
  ${({ $color }) => `color: ${$color};`}
  ${({ $inSelect }) => $inSelect && 'margin: -8px 6px -8px 0;'}
  ${({ $marginRight }) => typeof $marginRight !== undefined && `margin-right: ${$marginRight}px`}
`

export { LabelChip }
